module.exports = __webpack_public_path__ + "media/images/modal-bg-ca2b1c3447e63d28dec0347b83106e9a.png";